/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails
     */
    status_set_date?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status_set_date': !exists(json, 'status_set_date') ? undefined : json['status_set_date'],
        'status_set_reason': !exists(json, 'status_set_reason') ? undefined : json['status_set_reason'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSON(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status_set_date': value.status_set_date,
        'status_set_reason': value.status_set_reason,
    };
}

